import { render, staticRenderFns } from "./ConfidentialWidget.vue?vue&type=template&id=49913374&"
import script from "./ConfidentialWidget.vue?vue&type=script&lang=js&"
export * from "./ConfidentialWidget.vue?vue&type=script&lang=js&"
import style0 from "./ConfidentialWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports